/**
 * ScrollProgress Component
 *
 * A visual indicator that shows how far the user has scrolled down the page
 * Appears as a thin progress bar at the top of the viewport
 */
import React, { useRef, useEffect } from "react";

const ScrollProgress: React.FC = () => {
  const progressRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      if (progressRef.current) {
        progressRef.current.style.width = `${percent}%`;
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed top-0 left-0 w-full h-1 bg-transparent z-[100]">
      <div ref={progressRef} className="h-full bg-primary-500 transition-none" />
    </div>
  );
};

export default ScrollProgress; 
